import React from "react";
import CancelButton from '../../images/CancelIcon.svg';


export const CancelIcon = () => {
    return <img src={CancelButton} alt=""/>
}